// @ts-nocheck

import { init as initBgImageLayout } from './bgImageLayout'
import { shouldStopImageLoad } from '../utils/customElementsCommonUtils'
import { getByCompId, getElementCompId } from '@wix/thunderbolt-dom-utils'

function wixBgImageWrapper(WixElement, services, environmentConsts, contextWindow = window): any {
	const bgImageLayout = initBgImageLayout(contextWindow)

	class WixBgImage extends WixElement {
		constructor() {
			super()
		}

		reLayout() {
			// todo: temp experiment for measuring purposes, should be removed after test results
			if (shouldStopImageLoad(services)) {
				return
			}
			const domNodes = {}
			const measures = {}

			const imageId = getElementCompId(this, {
				experiments: environmentConsts.experiments,
				logger: environmentConsts.logger,
				document: contextWindow.document,
			})
			const imageInfo = JSON.parse(this.dataset.tiledImageInfo)
			const { bgEffectName } = this.dataset
			const { containerId } = imageInfo
			const container = getByCompId(containerId, {
				experiments: environmentConsts.experiments,
				logger: environmentConsts.logger,
				document: contextWindow.document,
			})

			domNodes[imageId] = this
			domNodes[containerId] = container
			imageInfo.displayMode = imageInfo.imageData.displayMode

			services.mutationService.measure(() => {
				bgImageLayout.measure(imageId, measures, domNodes, { containerId, bgEffectName }, services)
			})

			services.mutationService.mutate(() => {
				bgImageLayout.patch(imageId, measures, domNodes, imageInfo, environmentConsts, services)
			})
		}

		attributeChangedCallback(name, oldValue) {
			if (oldValue) {
				this.reLayout()
			}
		}

		disconnectedCallback() {
			super.disconnectedCallback()
		}

		static get observedAttributes() {
			return ['data-tiled-image-info']
		}
	}

	return WixBgImage
}

export { wixBgImageWrapper }
